import Page from 'src/components/molecules/page';
import { FC } from 'react';
import { FormSettingForm } from 'src/components/organisms/reservation-form-setting/form';
import { Container, Stack, Typography } from '@mui/material';

export const ReservationFormSettingEditPage: FC = () => {
  /* 定数宣言 */
  const title = '予約フォーム編集';
  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <FormSettingForm />
      </Container>
    </Page>
  );
};
